/**
 * Resolução centralizada da URL/host do Gerenciador de Produtos MX3.
 * -----------------------------------------------------------------
 * Ordem de prioridade:
 *   1. window.MX3_RUNTIME_CONFIG (gerado por runtime-config.js, que é
 *      criado/baixado pela tela "Configurações > Caminhos e URLs" do
 *      Gerenciador sempre que a URL do Gerenciador é alterada lá).
 *   2. Ambiente local (localhost) usa o proxy local automaticamente.
 *   3. GERENCIADOR_PROD_URL_FALLBACK abaixo - usado apenas como último
 *      recurso, se o runtime-config.js ainda não tiver sido gerado ou
 *      não tiver sido implantado no servidor.
 *
 * Ao mover o e-commerce e/ou o Gerenciador para outro domínio ou
 * diretório do cPanel, o caminho correto é atualizar "Caminhos e URLs"
 * no Gerenciador e publicar/baixar o novo runtime-config.js - isso já
 * cobre 100% dos casos em produção. O valor abaixo só entraria em jogo
 * se o runtime-config.js estivesse ausente, e agora existe em um único
 * lugar (antes era um valor repetido/hardcoded em 6 arquivos diferentes).
 */
const GERENCIADOR_PROD_URL_FALLBACK = 'https://sistemasintegradosonline.com/gerenciador_produtos_mx3';
const GERENCIADOR_LOCAL_URL = 'http://localhost/gerenciador_produtos_mx3';

function isLocalhost() {
    return typeof window !== 'undefined' && window.location.hostname === 'localhost';
}

export function gerenciadorUrl() {
    if (isLocalhost()) return GERENCIADOR_LOCAL_URL;
    return (typeof window !== 'undefined' && window.MX3_RUNTIME_CONFIG?.gerenciadorBaseUrl)
        || GERENCIADOR_PROD_URL_FALLBACK;
}

// Hostname do Gerenciador (derivado de gerenciadorUrl()), usado para
// identificar chamadas cross-domain independentemente de qual domínio
// esteja configurado em "Caminhos e URLs".
export function gerenciadorHost() {
    try {
        return new URL(gerenciadorUrl()).hostname;
    } catch (e) {
        try {
            return new URL(GERENCIADOR_PROD_URL_FALLBACK).hostname;
        } catch (e2) {
            return '';
        }
    }
}

// URL base das imagens de produto/seções (com barra final), na mesma
// prioridade acima.
export function gerenciadorImagesBaseUrl() {
    if (typeof window !== 'undefined' && window.MX3_RUNTIME_CONFIG?.imagesBaseUrl) {
        return window.MX3_RUNTIME_CONFIG.imagesBaseUrl;
    }
    return gerenciadorUrl().replace(/\/$/, '') + '/images/';
}

export { GERENCIADOR_PROD_URL_FALLBACK, GERENCIADOR_LOCAL_URL };
